module.exports = __webpack_public_path__ + "assets/gye.2414aa46.svg";